import {FixedVTag} from "../../entities/FixedVTag";
import {Location} from "../../entities/Location";
import {FixedVTagService} from "../../services/FixedVTagService";
import {NotificationService} from "../../services/NotificationService";
import {LocationService} from "../../services/LocationService";
import {EditModel} from "./EditModel";

export class EditFixedVTagModel extends EditModel<FixedVTag> {
  entityId:number;
  locations:Location[];
  static $inject = ['$q','FixedVTagService','NotificationService','LocationService'];
  constructor($q:ng.IQService,
              public service:FixedVTagService,
              public notifyService:NotificationService,
              public locationService:LocationService){
    super($q, service, FixedVTag);
  }
  loadData(entityId:number):ng.IPromise<boolean> {
    return super.loadData(entityId).then((ok) => {
      return this.locationService.getAll().then((locations)=>{
        this.locations = locations;
        return this.$q.when<boolean>(true);
      });
    });
  }
  verifyData():ng.IPromise<boolean>{
    if(this.entity.vTagID == null || this.entity.vTagID.length != 6 ){
      this.notifyService.notifyError("V-Tag ID is required and must be 6 digits.");
      return this.$q.when<boolean>(false);
    }
    return this.service.getFirstVTagMatch(this.entity.vTagID).then((foundTag)=>{
      if(foundTag != null && foundTag.id != this.entity.id)
      {
        this.notifyService.notifyError("Please choose a unique V-Tag ID.");
        return this.$q.when<boolean>(false);
      }
      else
        return this.$q.when<boolean>(true);
    });
  }
}
